<template>
  <div>
    <v-overlay v-model="loading" opacity='0.9' color='rgba(255, 255, 255 , 1)'>
      <v-img src='https://www.myq.gr/ext_files/prepaid/q/media/loading_orange.gif'></v-img>
    </v-overlay>
    <v-dialog width="40vw" v-model="error" overlay-opacity='0.9' overlay-color='rgba(255, 255, 255 , 1)'>
      <v-card light class='d-flex align-center justify-center' color='#FFF9F0'>
        <v-card-text class="text-center pa-10"><h3>{{errorMessage}}</h3></v-card-text>
      </v-card>
    </v-dialog>
    <v-container v-show="!loading">
      <v-row class='justify-center'>
          <v-col>
              <v-card color='transparent' elevation='0' class=" mt-5" width="100%">
                  <v-card-text class="justify-end">
                    <v-img
                    class="mt-12"
                    src="/ext_files/prepaid/q/media/koneLogo-orange.png"
                    max-width="320"
                    />
                    <!-- src="@/assets/images/logo.png" -->
                    <div class="under-title mt-3 max-ch-title mr-3">
                        <!-- Ο φίλος σου μόλις σε κάλεσε στην Q για να κερδίσετε και οι 2 extra προνόμια -->
                        {{ rafContentList.referralWelcomeTitle }}
                    </div>
                    <div class="main-text max-ch-text mr-3">
                        <!-- Έλα να γνωριστούμε καλύτερα. ο φίλος σου ..... πιστεύει οτι θα σου αρέσει η Q. Έλα στη παρέα μας και
                        θα δώσουμε unlimited επικοινωνία για WIND/Q και 1GB σε εσένα και στο φίλο σου, μόλις ενεργοποιήσεις
                        τον F2G αριθμό σου. -->
                        {{ rafContentList.referralWelcomeText }}
                    </div>
                  </v-card-text>
              </v-card>
          </v-col>
          <v-col>
              <v-card rounded='xl' color='#FFF9F0' elevation='0' class="justify-center mt-5 mx-auto py-3 px-6" width="90%">
                  <div class="orange-title">
                        <!-- Πως λειτουργεί -->
                        {{getMessages['raf.landing.howitworks']}}
                    </div>
                    <div class="main-text">
                        {{getMessages['raf.landing.filltheform']}}
                        <!-- Συμπλήρωσε τα στοιχεία σου και ακολούθησε τις οδηγίες που θα βρείς στο email που θα
                        λάβεις στην επόμενη σελίδα. -->
                    </div>
                    <v-form v-model="valid">
                        <v-row>
                            <v-col>
                                <v-text-field
                                    rounded outlined dense
                                    v-model="firstname"
                                    :rules="nameRules"
                                    :label="getMessages['raf.landing.name']"
                                    required
                                ></v-text-field>
                                <!-- Όνομα -->
                            </v-col>
                        </v-row>
                        <v-row class="mt-0">
                            <v-col>
                                <v-text-field
                                    rounded outlined dense
                                    v-model="surname"
                                    :rules="surNameRules"
                                    :label="getMessages['raf.landing.surname']"
                                ></v-text-field>
                                    <!-- required -->
                                <!-- Επώνυμο -->
                            </v-col>
                        </v-row>
                        <v-row class="mt-0">
                            <v-col>
                                <v-text-field
                                    rounded outlined dense
                                    v-model="email"
                                    :rules="emailRules"
                                    label="Email"
                                    required
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row class="mt-0">
                            <v-col>
                                <v-checkbox class='mt-0'
                                    v-model="acceptTerms"
                                    :rules="acceptRules"
                                    required
                                >
                                <template v-slot:label>
                                    {{getMessages['raf.landing.accepttext']}}
                                    <!-- <a href="/gr/kone-terms/" class="ml-1">όρους και τις προυποθέσεις</a> -->
                                    <a
                                      target="_blank"
                                      class="ml-1"
                                      :href="$store.getters.getTermsUrl"
                                      @click.stop
                                      v-on="on"
                                    >
                                      {{getMessages['raf.landing.termslink']}}
                                    </a>
                                    <!-- Αποδέχομαι τους  -->
                                    <!-- όρους και τις προυποθέσεις -->
                                </template>
                                </v-checkbox>
                            </v-col>
                        </v-row>
                        <v-row class="pb-5 mx-auto justify-center text-center">
                            <v-col class='shrink'>
                                <v-btn
                                    elevation='0' 
                                    large
                                    class="white--text px-16"
                                    color="#F54D23"
                                    rounded
                                    :disabled="!valid"
                                    @click="signUp"
                                >
                                {{getMessages['raf.landing.signup']}}</v-btn>
                                <!-- Εγγραφή -->
                            </v-col>
                        </v-row>
                    </v-form>
                    <div class="d-flex flex-column" id="captcha-box" v-show="captchaVersion=='v2'">
                      <div class="mx-auto" id="captchaTest"></div>
                      <div class="row mx-auto">
                        <div class="col-md-6 col-xs-12">
                          <p class="error"><span class="field-validation-error"></span></p>
                        </div>
                      </div>
                    </div>
                    <p class="recaptcha-disclaimer">
                      This site is protected by reCAPTCHA and the Google
                      <a href="https://policies.google.com/privacy" target="_blank">Privacy Policy</a>
                      and
                      <a href="https://policies.google.com/terms" target="_blank">Terms of Service</a>
                      apply.
                    </p>
                    <v-card v-if="thankYou" class='mx-5 mb-5 text-center' color='#FFBEA2' elevation='0' rounded='pill'>
                        <div class="valuation-text">
                            {{ thankYouText }}
                            <!-- raf.landing.confirmation -->
                        </div>
                    </v-card>
              </v-card>
          </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>

import axios from 'axios'
import { mapGetters } from 'vuex'

export default {
  name: 'Landing',
  props: {
    msg: String
  },
  data () {
    return {
      payload: {},
      captchaVersion: 'v3',
      widgetId: "",
      locale: '',
      error:false,
      errorMessage:'Κάτι πήγε στραβά, παρακαλώ δοκιμάστε ξανά αργότερα.',
      loading: true,
      test: '',
      name: '',
      surname: '',
      acceptTerms: false,
      acceptOther: false,
      thankYou: false,
      submit: false,
      valid: false,
      firstname: '',
      lastname: '',
      acceptanceId: '',
      thankYouText: 'Ευχαριστούμε! Σου έχουμε στείλει ένα mail για να επαλυθεύσεις τον λογαριασμό σου και να συνεχίσεις',
      nameRulesText:{en:'Enter your name',gr:'Γράψε μας το όνομά σου'},
      nameRulesTextReq:{en:'The name should not exceed 40 characters',gr:'Το όνομα δεν πρέπει να περιέχει περισσότερους από 40 χαρακτήρες'},
      nameRules: [
        v => !!v || this.nameRulesText[this.$store.getters.getLocale],
        v => v.length <= 40 || 'Το όνομα δεν πρέπει να περιέχει περισσότερους από 40 χαρακτήρες',
        // raf.landing.inputname
      ],
      surNameRules: [
        v => v.length <= 40 || this.nameRulesTextReq[this.$store.getters.getLocale],
        // raf.landing.inputsurname
      ],
      email: '',
      emailRulesText:{en:'Enter your email',gr:'Γράψε μας το μέιλ σου'},
      emailRulesTextReq:{en:'The email should be a valid email address',gr:'Το email δεν είναι έγκυρο'},
      emailRules: [
        v => !!v || this.emailRulesText[this.$store.getters.getLocale],
        // raf.landing.inputemail
        // v => /.+@.+/.test(v) || 'Το email πρέπει να είναι έγκυρο',
        v => !v || /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || this.emailRulesTextReq[this.$store.getters.getLocale],
        // raf.landing.validemail
      ],
      acceptRulesText:{en:'Accept the terms and conditions to proceed',gr:'Αποδέξου τους όρους για να προχωρήσεις'},
      acceptRules: [
        v => !!v || this.acceptRulesText[this.$store.getters.getLocale],
        // raf.landing.acceptterms
      ],
      // rafContentList: {
      //   referralWelcomeTitle : "Ο φίλος σου μόλις σε κάλεσε στην Q για να κερδίσετε και οι 2 extra προνόμια",
      //   referralWelcomeText : "Έλα να γνωριστούμε καλύτερα. ο φίλος σου ..... πιστεύει οτι θα σου αρέσει η Q. Έλα στη παρέα μας και θα δώσουμε unlimited επικοινωνία για WIND/Q και 1GB σε εσένα και στο φίλο σου, μόλις ενεργοποιήσεις τον F2G αριθμό σου."
      // }
    }
  },
  computed: {
    rafContentList() {
      return this.getRafContentList() 
    },
    getMessages () {
      return this.$store.getters.getMessages
    }
  },
  watch: {
    rafContentList() {
      
    }
  },
  methods: {
     ...mapGetters([
      'getRafContentList',
    ]),
    signUp () {
      var self = this
      if (this.valid) {
        this.payload = {
            "caller": {
              "callingSystem":"myQweb",
              "salesCode":"",
              "username":"username",
              "data":"",
              "locale":this.locale,
              "channel":"Q"
            },
            "shareId" : this.shareId,
            "name": this.firstname,
            "surname": this.surname,
            "email": this.email,
            "captchaToken": '',
            "captchaVersion": ''
          }
        if (this.validateCaptcha()){
          this.loading = true
          var v3Key = document.getElementsByTagName("body")[0].dataset.captchav3;
          grecaptcha.execute(v3Key, {action: 'qkoneregister'}).then(function(token) {
            self.payload.captchaToken = token;
            if (self.captchaVersion == "v2") {
                self.payload.captchaToken = grecaptcha.getResponse(self.widgetId);
            }
            self.payload.captchaVersion = self.captchaVersion;
          }).then(function() {
            axios.post('/apiv2/referafriend/acceptInvitation', self.payload)
            .then(response => {
              if (response.data.errorLevel === 1) {
                if (response.data.errorCode == 21027) {
                  if (self.captchaVersion != "v2") {
                    var v2Key = document.getElementsByTagName("body")[0].dataset.captchav2;
                    grecaptcha.ready(() => {
                      self.widgetId = grecaptcha.render('captchaTest', {
                        'sitekey' : v2Key,
                        'theme' : 'light'
                      });
                    });
                  }
                  self.captchaVersion = "v2";
                }else{
                  self.thankYouText = response.data.errorMessage
                  self.thankYou = true
                  document.cookie = "rafAcceptanceId="+response.data.acceptanceId
                  document.cookie = "rafShareId="+self.shareId
                  self.$nextTick(() => {
                    handleDataLayer.init();
                    handleDataLayer.pushRafDataLayer({
                      "event" : {
                        "initiator": "friend-registration",
                        "referrerEligibleForRAF": true,
                        "emailVerified": false,
                        "segment": this.rafContentList.segmentId
                      }
                    })
                  })
                }
              }
              else {
                document.cookie = "rafAcceptanceId="+response.data.acceptanceId
                document.cookie = "rafShareId="+self.shareId
                self.$store.commit('setRefMsisdn', response.data.referrerData.msisdn)
                self.$store.commit('setAcceptanceId', response.data.referrerData.acceptanceId)
              }
              if (response.data.success === true) {
                self.$emit('verified', true)
              }
            }).catch(error => {
              self.error = true
              self.errorMessage = error.response.data.errorMessage
            }).finally(() => {
              self.loading = false
            })
          })
        }
      } else {
        console.warn('An error occured while submitting the form.');
      }
    },
    validateCaptcha() {
      if (this.captchaVersion == "v2" && grecaptcha.getResponse(this.widgetId).length == 0) {
        $('body').data('locale') == "el_GR" ? 
          $('#captcha-box > div > div > p > span').html('To captcha πρέπει να συμπληρωθεί.') :
          $('#captcha-box > div > div > p > span').html('Please fill in the captcha.');
        $("#captcha-box > div > div > p > span").show();
      } else {
        $('#captcha-box > div > div > p > span').html('') 
        $("#captcha-box > div > div > p > span").hide();
      }
      return this.captchaVersion == "v3" || grecaptcha.getResponse(this.widgetId).length != 0;
    },
  },
  mounted () {
    let locale = 'el_GR'
    if (document.getElementsByTagName('body')[0].dataset.locale !== undefined) {
      locale = document.getElementsByTagName('body')[0].dataset.locale
    }
    this.locale = locale
    this.thankYouText = this.getMessages['raf.landing.confirmation']
    this.shareId = new URL(location.href).searchParams.get("id");
    axios.post('/apiv2/referafriend/getShareIdInfo', {
      "caller": {
          "callingSystem":"myQweb",
          "salesCode":"",
          "username":"username",
          "data":"",
          "locale":this.locale,
          "channel":"Q"
      },
      "shareId": this.shareId
    })
    .then(response => {
      this.$store.commit('setRafContentList', response.data.content)
      this.$store.commit('setTermsUrl', response.data.rafTcLink)
      if (response.data.errorLevel === 1) {
        this.errorMessage = response.data.errorMessage
        this.error = true
      } else {
        setTimeout(() => {
          handleDataLayer.init();
          handleDataLayer.pushRafDataLayer({
            "event" : {
              "initiator": "friend-registration",
              "referrerEligibleForRAF": false,
              "segment":this.rafContentList.segmentId
            }
          })
        }, 1000)
        // this.rafContentList = response.data.content
      }
      })
    .catch(error => {
      this.errorMessage = error.response.data.errorMessage
      this.error = true
      // handleDataLayer.init();
      // handleDataLayer.pushRafDataLayer({
      //   "event" : {
      //     "initiator": "friend-registration",
      //     "referrerEligibleForRAF": false,
      //     "segment":"12Gbfor12months"
      //   }
      // })
    }).finally(() => {
      this.loading = false
    })

    // Check if there is a cookie with the acceptanceId and log its value
    if (document.cookie.indexOf("rafAcceptanceId") > -1) {
      if (document.cookie.indexOf("rafShareId") > -1 && document.cookie.split("rafShareId=")[1].split(";")[0] === this.shareId) {
        this.loading = true
        this.acceptanceId = document.cookie.split("rafAcceptanceId=")[1].split(";")[0]
        if (this.acceptanceId === "null") {
          this.acceptanceId = null
        }
        axios.post('/apiv2/referafriend/acceptInvitation', {
          "caller": {
            "callingSystem":"myQweb",
            "salesCode":"",
            "username":"username",
            "data":"",
            "locale":this.locale,
            "channel":"Q"
          },
          "acceptanceId" : this.acceptanceId
        })
        .then(response => {
          if (response.data.success === false) {
            this.thankYouText = response.data.errorMessage
            if (response.data.referralData !== null){
              this.email = response.data.referralData.email
              this.firstname = response.data.referralData.name
              this.surname = response.data.referralData.surname
              this.acceptTerms = true
            }
          } else {
            // $emit the msisdn
            this.$emit('verified', true)
            this.$store.commit('setRefMsisdn', response.data.referrerData.msisdn)
            this.$store.commit('setAcceptanceId', response.data.referrerData.acceptanceId)
            setTimeout(() => {
              handleDataLayer.init();
              handleDataLayer.pushRafDataLayer({
                "event" : {
                  "initiator": "friend-registration",
                  "referrerEligibleForRAF": true,
                  "emailVerified": true,
                  "segment": this.rafContentList.segmentId
                }
              })
            }, 1000)
          }
        }).catch(error => {
          if(error.response.data.errorMessage){
            this.thankYouText = error.response.data.errorMessage
          } else {
            this.thankYouText = 'Παρουσιάστηκε κάποιο πρόβλημα. Παρακαλώ προσπαθήστε ξανά.'
          }
        }).finally(() => {
          this.thankYou = true
          this.loading = false
        })
      }
    }
  }
}
</script>